<template>
  <div class="bodyNews">
    <el-row :gutter="24">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="title">
          <h2>{{ navlist.title }}</h2>
        </div></el-col
      >
    </el-row>

    <el-row :gutter="24">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="title2">
          <p>作者：{{ navlist.author }}</p>
          <p>发布时间：{{ navlist.ReleaseTime }}</p>
        </div></el-col
      >
    </el-row>

    <el-row :gutter="24">
      <el-col :xs="2" :sm="2" :md="24" :lg="24" :xl="24">
        <div class="title2">
          <div class="content" v-html="navlist.content"></div></div
      ></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      workTask: [],
      navlist: {
        title: "东方集市商家版隐私政策",
        author: "东方集市",
        ReleaseTime: "2022-03-08 09:20:31",
        content: `<p style="text-align: right; text-indent: 2em;">
    更新日期：2022年03月01日
</p>
<p style="text-align: right; text-indent: 2em;">
    生效日期：2022年03月08日
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px; text-indent: 2em;">东方集市商家版（以下或称“我们”）非常注重保护用户（以下或称“您”）的个人信息，我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">【特别提示】请您在使用我们提供的各项产品/服务前，仔细阅读并充分理解本《隐私政策》（重点内容我们已将字体加粗请您特别关注）并作出相应选择。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私政策收集、使用、保存、共享和保护您的相关信息。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">如对本隐私政策有任何疑问，您可以通过我们的网站（</span></strong><span style="letter-spacing: 0px;">https://www.df-js.cn/</span><strong><span style="letter-spacing: 0px;">）或东方集市商家版App上的客服系统与我们联系。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">本《隐私政策》所称的</span><strong><span style="letter-spacing: 0px;">“东方集市商家版”的产品/服务是指梅州神寻科技有限公司通过下述途径向您提供的产品/服务：东方集市网站（</span></strong><span style="letter-spacing: 0px;">https://www.df-js.cn/</span><strong><span style="letter-spacing: 0px;">）、手机应用程序（下称“APP”或“App”）、电脑客户端程序、相关微信开放平台账号或小程序以及我们现有和/或未来设立的其他相关服务平台、途径等。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">本《隐私政策》所称的“东方集市商家版”（包括其关联方），是指梅州神寻科技有限公司（注册地址：广东省梅州市五华县奥园广场4栋3座206号）及现有和/或未来设立的相关关联企业的单称或合称。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">东方集市商家版所有的产品/服务（包括东方集市商家版提供的产品/服务及未设独立隐私政策的东方集市商家版关联方提供的产品/服务）均适用本隐私政策。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">请您注意，您应保证在使用东方集市商家版服务中所提供的一切数据信息均为真实，且经过合法途径获得，如其中包含第三方个人信息（如您的员工信息、会员信息、供应商信息以及商家后续使用新增功能时所提供的个人信息），请确认您已取得该信息所有方的充分、合法的授权，一旦您在使用我们服务的过程中提供此类信息，我们将认为该类信息均为您有权处理，不存在任何违反法律、法规或侵犯任何第三方合法权利的情形。本政策不适用于您通过我们的产品/服务而接入的其他第三方产品/服务（“其他第三方”包括但不限于：您的交易相对方、任何除东方集市商家版及其关联方以外的第三方服务提供者及/或其网站、APP、电脑客户端程序、微信开放平台账号或小程序或其他相关服务平台、途径等），具体规定请参照该第三方的隐私政策或类似声明。您同时确认，我们无须为您违反第三方的相关隐私政策或类似声明的行为承担任何责任。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">一、我们如何收集和使用您的个人信息</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">我们会出于本政策所述的以下目的，收集和使用您的个人信息：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（一）帮助您登录我们的东方集市商家版平台</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">为登录我们的东方集市商家版平台，以便我们为您提供服务，您需要提供您的手机号码（我们将在向第三方呈现有关手机号码前对其进行脱敏处理）、角色信息、网络身份识别信息（包括头像、昵称及相应账号密码）等。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（二）更好的为您提供产品/服务</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1、您向我们提供的信息</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">为便于向您提供产品/服务，我们有权从身份校验、完成交易、售后及客户服务、提供安全保障的多种角度，收集您向我们提供的联系人信息（姓名、性别、电话号码）、法定代表人信息（姓名、手机号、身份证号、自愿选择提供的银行卡号）、收货地址、电子邮箱、银行账户或其他支付工具的账户信息，您在使用东方集市商家版服务的过程中所提交的任何文字、照片、视频各种形式的信息，也可能会包含或者关联到您的个人信息，我们将对于上述信息中涉及的个人信息予以严格保护。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2、我们在您使用服务过程中收集的信息</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">为向您展示有关订单信息，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">3、当您与我们联系时，我们可能会收集您的通信/通话记录和内容或您留下的联系方式信息，以便与您联系、帮助您解决问题，或记录相关问题的处理方案及结果。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">4、当您参与我们的推广活动和问卷调查过程中，我们可能会收集您主动提供的相关信息。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">5、为了解决纠纷、判定责任所需要收集的信息。请您注意，在履行使用隐私号码保护订单时，您在接听和拨打电话的通话过程中都可能会被录音，该录音信息的获取与使用目的如下：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）经授权，当商家、消费者、骑手间出现服务纠纷时，我们可调取并使用录音信息作为解决纠纷、判定责任的参考依据。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）我们将切实保障通话双方的隐私安全，录音将上传至我们的服务器保存，其他各方无法自行下载、调取或播放录音。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（3）除以下情形外，我们不会将录音提供给任何人（包括通话主、被叫方）：a.行政、司法机关或其他有权机关依法定程序调取；b.被录音的一方持司法机关出具的法律文件依法调取。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（4）录音在保存7天后将自动永久删除，如遇差评、投诉、尚未处理完毕纠纷的，我们将适当延长录音保存期限。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（5）受网络状态稳定性等限制，极端情况下，可能会出现无法录音或部分录音无法听清等录音失败情形，如遇此类情形，我们无需承担责任。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">6、我们通过间接收集到的您的个人信息</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">为能向您提供更优质的服务，同时为能确认交易状态及为您提供售后与争议解决服务，经您授权后我们会通过您选择的交易对象和交易直接涉及的第三方信息系统、支付机构等收集与交易进度相关的您的交易、支付、配送信息，或者将您的信息共享给上述服务提供者，以便于我们处理您的订单并保证服务的顺利完成，或者更好地预防诈骗、刷单等恶意行为。我们会依据法律法规的要求以及与第三方的约定，经您授权后向东方集市商家版的关联方、合作伙伴获得您的有关信息，并对其信息来源的合法性进行确认后使用您的这些信息。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">我们承诺将对上述信息中涉及的个人信息予以严格保护。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">请注意，无法与任何特定个人直接建立联系的数据，不属于个人信息。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（四）提供其他附加服务</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">我们会在符合法律规定并根据您具体授权的情况下收集并使用如下信息。这类信息将在您选择的具体功能和业务场景中进行收集，如果您不提供这些信息，不会影响基本功能的使用，您可以随时通过设置关闭特定附加服务的有关权限授权。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1、基于位置的附加服务。为了向用户展示门店地理位置，以及方便您确认配送的距离，当您首次启动客户端后，我们会申请获得授权，收集您的位置信息以实现上述目的。</span><strong><span style="letter-spacing: 0px;">我们会使用有关技术获取您的位置信息（准确度会有所不同），这些技术包括&nbsp;IP&nbsp;地址、GPS&nbsp;以及能够提供相关信息的WLAN（如Wi-Fi）&nbsp;接入点、蓝牙和基站等。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2、基于麦克风的语音附加服务。为了向您提供语音录入及语音助手功能，当您主动使用该功能时，我们会申请获得授权。</span><strong><span style="letter-spacing: 0px;">请您知晓，获得授权后，我们仅会在您主动选择语音录入或启动语音助手时收集语音信息。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">3、基于拨打电话的附加服务。为了方便您使用我们的虚拟号码联系客户或骑手等人群的功能，当您主动拨号时，我们会申请获得授权。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">4、基于相机、相册和存储的图片/视频上传和下载附加服务。为了向您提供上传照片或视频、扫码，以及读取和写入您拍摄的照片和视频的功能，当您主动拍照、扫码、上传图片等清晰时，我们会申请获得授权。</span><strong><span style="letter-spacing: 0px;">请您知晓，获得授权后，我们仅会在您主动选择拍照、上传等功能时收集照片、视频信息。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">5、基于剪切板地服务。为了向您更方便填写信息，我们会申请获得授权。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（五）为您提供安全保障</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">为了保障您的账号安全、交易安全以及系统运行安全，满足法律法规和我们协议规则的相关要求，在您使用我们的产品/服务过程中，经您授权我们会获取您的设备信息，包括您使用的设备属性、连接和状态信息，例如设备型号、唯一设备标识符（如IMEI/androidID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等）、设备MAC地址、软件列表、电信运营商等。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">为提高您使用我们提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会使用或整合您的个人信息以及我们的关联方、合作伙伴取得您授权或者依法共享的信息，根据您的使用习惯和常用软件信息来综合判断您的账号及交易风险，包括验证身份，预防、发现、调查可能存在的欺诈、网络病毒、网络攻击的安全风险以及违反我们或关联方协议、政策或规则的行为，以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接（“URL”）。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（六）征得同意的例外</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1、与国家安全、国防安全有关的；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2、与公共安全、公共卫生、重大公共利益有关的；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">3、与犯罪侦查、起诉、审判和判决执行等有关的；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">5、所收集的个人信息是个人信息主体自行向社会公众公开的；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">7、根据您的要求签订合同所必需的；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">9、为合法的新闻报道所必需的；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">11、法律法规规定的其他情形。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">三、自启动和关联启动说明</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1. 为确保本APP处于关闭或后台运行状态下可正常接收到极光推送的消息，需使用自启动能力，将存在一定频率通过系统发送广播唤醒本APP自启动或关联启动行为，这是因实现功能及服务所必要的。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2.当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容，在未征得您同意情况下不会有自启动或关联启动。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">3.当使用APP进行支付订单时，会关联启动第三方APP，实现第三方支付。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">四、我们如何使用Cookie和同类技术</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">（一）Cookie的使用</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">为确保网站正常高效运转、为您获得更轻松的访问体验，我们会在您的设备终端/</span><span style="letter-spacing: 0px;">系统上存储名为&nbsp;</span><span style="letter-spacing: 0px;">Cookie的小数据文件。Cookie会帮助您在后续访问我们网站时调用您的信息，简化您填写个人信息（例如一键登录等）的流程；为您提供安全购物的偏好设置;</span><span style="letter-spacing: 0px;">保护您的数据安全等。我们不会将&nbsp;</span><span style="letter-spacing: 0px;">Cookie</span><span style="letter-spacing: 0px;">用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除&nbsp;</span><span style="letter-spacing: 0px;">Cookie</span><span style="letter-spacing: 0px;">。您可以清除计算机或移动设备上保存的所有&nbsp;</span><span style="letter-spacing: 0px;">Cookie，您有权接受或拒绝Cookie。大多数浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie；另外，您也可以清除软件内保存的所有Cookie。但您可能因此无法完全体验我们某些便捷性和安全性的服务功能。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">三、我们如何共享、转让、公开披露您的个人信息</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（一）共享</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">我们不会与平台以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">基于法定情形下：根据法律法规的规定、诉讼争议解决需要，或行政、司法等有权机关依法提出的要求；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">与关联公司共享：为向用户提供一致化服务以及便于用户进行统一管理，我们会基于必要性的前提下将您的个人信息与我们的关联公司共享。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">与合作伙伴分享：我们可能会向业务合作伙伴共享为您提供服务所必要的订单信息、账户信息、支付信息。我们的业务合作伙伴包括合作商、第三方服务合作商业务合作伙伴。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">基于协议约定：依据您与我们签署的相关协议（包括在线签署的电子协议及平台规则）或法律文件，有必要向第三方共享时；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">基于合理商业习惯：例如与第三方共享联合营销活动中的中奖信息，以便第三方能及时向您发放奖品；或者在进行资本市场活动（包括但不限于:首次公开发行股票、债券发行）而接受尽职调查时；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">基于学术研究：例如为科研机构开展统计或学术研究之必要；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">基于符合法律法规的社会公共利益。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">我们会通过应用程序接口（API）、软件工具开发包（SDK）与第三方进行必要的数据共享，不同版本的第三方SDK会有所不同，一般包括第三方账号登录类、分享类、第三方支付类、地图导航类、厂商推送类、统计类等，我们会对第三方进行严格的安全检测并约定数据保护措施。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">接入的相关SDK目录如下：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1.&nbsp;</span><span style="letter-spacing: 0px;">极光推送SDK</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）</span><span style="letter-spacing: 0px;">收集及共享的个人信息类型：设备信息，应用信息（应用崩溃信息，软件列表等相关信息）；运行中进程信息；系统信息；网络信息。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）使用目的：推送消息</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（3）第三方主体：深圳市和讯华谷信息技术有限公司</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（4）官网链接：</span><a href="file:///E:/%E6%A1%8C%E9%9D%A2/%E6%96%B0%E5%BB%BA%20DOCX%20%E6%96%87%E6%A1%A3.docx#/systemArticle/show/_blank"><span style="text-decoration:underline;"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://www.jiguang.cn/</span></span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（5）隐私政策：</span><a href="file:///E:/%E6%A1%8C%E9%9D%A2/%E6%96%B0%E5%BB%BA%20DOCX%20%E6%96%87%E6%A1%A3.docx#/systemArticle/show/_blank"><span style="text-decoration:underline;"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://www.jiguang.cn/license/privacy</span></span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2.&nbsp;</span><span style="letter-spacing: 0px;">环信SDK</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）</span><span style="letter-spacing: 0px;">收集及共享的个人信息类型：设备信息或运行中的进程信息</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）使用目的：联系</span><span style="letter-spacing: 0px;">商家、联系骑手、联系客服</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（3）第三方主体：北京易掌云峰科技有限公司</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（4）官网链接：</span><a href="file:///E:/%E6%A1%8C%E9%9D%A2/%E6%96%B0%E5%BB%BA%20DOCX%20%E6%96%87%E6%A1%A3.docx#/systemArticle/show/_blank"><span style="text-decoration:underline;"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://www.easemob.com/</span></span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（5）隐私政策合规：</span><a href="file:///E:/%E6%A1%8C%E9%9D%A2/%E6%96%B0%E5%BB%BA%20DOCX%20%E6%96%87%E6%A1%A3.docx#/systemArticle/show/_blank"><span style="text-decoration:underline;"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://www.easemob.com/news/privacy</span></span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">3.&nbsp;支付宝SDK</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）收集及共享的个人信息类型：设备信息、您安装的应用信息或运行中的进程信息</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）使用目的：第三方登录、支付订单</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（3）第三方主体：支付宝（杭州）信息技术有限公司</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（4）官网链接：</span><span style="text-decoration:underline;"><span style="letter-spacing: 0px;">https://open.alipay.com/</span></span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（5）隐私政策合规：</span><span style="text-decoration:underline;"><span style="letter-spacing: 0px;">https://opendocs.alipay.com/common/02kiq3</span></span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">4.&nbsp;</span><span style="letter-spacing: 0px;">微信登录/支付SDK</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）收集及共享的个人信息类型：设备信息、运行中进程信息、应用安装列表</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）使用目的：微信授权登录；微信分享；支付订单</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（3）第三方主体：</span><a href="https://baike.baidu.com/item/%E6%B7%B1%E5%9C%B3%E5%B8%82%E8%85%BE%E8%AE%AF%E8%AE%A1%E7%AE%97%E6%9C%BA%E7%B3%BB%E7%BB%9F%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/6951823?fromModule=lemma_inlink"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">深圳市腾讯计算机系统有限公司</span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（4）官网链接：</span><a href="https://open.weixin.qq.com/"><span style="text-decoration:underline;"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://open.weixin.qq.com/</span></span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（5）开发者服务协议：</span><span style="text-decoration:underline;"><span style="letter-spacing: 0px;">https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl</span></span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（6）隐私政策合规：</span><a href="https://www.qq.com/contract.shtml"><span style="text-decoration:underline;"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://www.qq.com/contract.shtml</span></span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">5.&nbsp;网易易盾</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）收集及共享的</span><span style="letter-spacing: 0px;">个人信息类型：设备信息（IMEI、AndroidID、MAC地址），手机号码</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）使用目的：手机号一键登录</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（3）第三方主体：杭州网易易盾科技有限公司</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（7）</span><span style="letter-spacing: 0px;">官网链接：https://dun.163.com/</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（4）项目隐私链接：</span><a href="https://dun.163.com/clause/privacy"><span style="text-decoration:underline;"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://dun.163.com/clause/privacy</span></span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">6.com.cmic.sso(移动;中国移动)</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）收集及共享的</span><span style="letter-spacing: 0px;">个人信息类型：设备信息（IMEI、AndroidID、MAC地址），手机号码</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）使用目的：手机号一键登录</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（3）官网链接：</span><a href="https://cmic.com/"><span style="text-decoration:underline;"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://cmic.com</span></span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">7.&nbsp;cn.com.chinatelecom(电信;中国电信;天翼)</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）收集及共享的</span><span style="letter-spacing: 0px;">个人信息类型：设备信息（IMEI、AndroidID、MAC地址），手机号码</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）使用目的：手机号一键登录</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">8.&nbsp;高德地图</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）收集及共享的</span><span style="letter-spacing: 0px;">个人信息类型：硬件序列号、设备MAC地址、唯一设备识别码与本机位置权限</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）</span><span style="letter-spacing: 0px;">使用目的:获取用户位置信息，更好地给用户提供本地生活服务</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（5）第三方主体：高德软件有限公司</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（8）</span><span style="letter-spacing: 0px;">官网链接：https://lbs.amap.com/</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（9）项目隐私链接：</span><a href="https://lbs.amap.com/pages/privacy/"><span style="color: rgb(1, 170, 237); letter-spacing: 0px;">https://lbs.amap.com/pages/privacy/</span></a>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">9.&nbsp;</span><span style="letter-spacing: 0px;">银联云闪付SDK</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（1）收集及共享的个人信息类型：</span><span style="letter-spacing: 0px;">设备型号、App安装信息（只读云闪付App）、收集应用列表和获取设备型号</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（2）</span><span style="letter-spacing: 0px;">使用目的:用户使用云闪付支付渠道完成付款</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（3）第三方主体：中国银联股份有限公司</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（4）</span><span style="letter-spacing: 0px;">项目隐私链接：https://wallet.95516.com/s/wl/WebAPP/helpAgree/page/agreement/regPrivacy.html?cntryCode=86</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">请您知悉，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，对我们仅为实现本政策中声明的目的与之共享个人信息的公司、组织和个人，我们会与其签署严格的信息保护和保密协定，要求他们遵守协议并采取相关的安全措施来保护您的个人信息。</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（二）转让</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2、在我们发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">（三）公开披露</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">我们不会公开披露您的个人信息，但以下情况除外：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1、基于您的主动选择或获得您的明确同意，我们可能会公开您的相关个人信息；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2、&nbsp;如果我们确定您出现违反法律法规或严重违反东方集市商家版相关协议、规则的情况，或为保护东方集市商家版及其关联公司用户或公众的人身财产安全免遭侵害以及维护良好的公平交易环境，我们可能依据法律法规或东方集市商家版相关协议、规则披露您的相关个人信息，例如若您销售不符合安全标准的商品而严重违反东方集市商家版规则时，我们可能会公开披露您的店铺主体信息与相关处罚情况。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">3、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">五、我们如何保护您个人信息的安全</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">为保障您的信息安全，我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息，防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息，使用加密技术确保数据的保密性；使用受信赖的保护机制防止数据遭到恶意攻击；部署访问控制机制，确保只有授权人员才可访问个人信息；以及举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">六、您如何管理您的个人信息</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">您对您的个人信息享有以下权利:</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1、您有权访问、更正、删除您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式管理您的信息:</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">账户信息——您可以访问、更正您账户中的个人资料及账号信息（如手机号，也可以更改您的密码），您可以通过访问东方集市商家版App在[我的]---[当前账号]中执行此类操作。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2、您可以改变您授权同意的范围或撤回授权</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">您可以通过在东方集市商家版后台或者App中通过相应页面提示解除绑定、删除信息、更改隐私设置或者在系统中关闭设备权限功能等方式改变同意范围或撤回您的授权。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权已经开展的个人信息处理。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">3、您可以注销账户</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">您有权注销您的东方集市商家版账户，您可以通过联系您的销售经理或者客服人员协助您进行账户注销。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">如果您无法通过上述链接管理这些个人信息，您可以随时通过本隐私政策中提供的反馈方式联系我们。我们将在核实您身份之日起的15天内回复您的访问请求。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">七、您的个人信息如何在全球范围转移</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">1、法律法规有明确规定；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">2、获得您的明确授权；</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">3、您通过互联网进行跨境交易等个人主动行为。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">针对以上情形，我们会确保依据本隐私权政策对您的个人信息提供足够的保护。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">八、通知与修订</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在我们网站、移动端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <strong><span style="letter-spacing: 0px;">九、如何联系我们</span></strong>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">如果您对于我们的个人信息处理行为存在任何投诉举报需求，请您使用以下方式联系我们：</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">个人信息保护负责人邮箱：privacy@shenthing.com</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">联系地址：广东省梅州市五华县奥园广场4栋3座206号</span>
</p>
<p style="margin: 0px 0px 10px; text-indent: 2em; padding: 0px; text-align: left;">
    <span style="letter-spacing: 0px;">您还可以通过东方集市网站（https://www.df-js.cn/）或App上提供的联系方式/客服系统与我们联系并作充分描述，我们将在核实您身份之日起的15天内答复您的请求并尽力解决。如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向我们的住所地有管辖权的法院提起诉讼。</span>
</p>`,
      },
    };
  },
  created() {
    this.workTask = this.$route.query.id;
    console.log(this.workTask);
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.content {
  width: 60rem;
  margin: 5rem auto;
  color: #000000;
  ::v-deep {
    img {
      width: 100%;
    }
  }
}
.content {
  
}
.bodyNews {
  margin: 20px auto;
}
.bodyNews p {
  color: #aaa;
}
.title2 p {
  display: inline;
  padding-left: 15px;
  font-size: 16px;
}
.title h2 {
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/merchantPolicy.vue